import React from "react";

const ERPModulesAndStats = () => {
  const modules = [
    { icon: "fa-dollar-sign", title: "Finance", desc: "Complete financial management system" },
    { icon: "fa-users", title: "HR Management", desc: "Employee and workforce management" },
    { icon: "fa-chart-line", title: "Sales", desc: "Sales and revenue management" },
    { icon: "fa-building", title: "Fixed Asset", desc: "Asset tracking and management" },
    { icon: "fa-user-cog", title: "System Admin", desc: "System configuration and management" },
    { icon: "fa-file-invoice-dollar", title: "IFRS", desc: "International financial reporting" },
    { icon: "fa-chart-bar", title: "MIS / Reporting", desc: "Business intelligence and reporting" },
    { icon: "fa-hard-hat", title: "Construction", desc: "Construction project management" },
  ];

  const stats = [
    { icon: "fa-project-diagram", value: "100+", title: "Projects Completed", desc: "Successfully delivered projects" },
    { icon: "fa-users", value: "50+", title: "Expert Team Members", desc: "Skilled professionals" },
    { icon: "fa-smile", value: "80+", title: "Satisfied Clients", desc: "Across various industries" },
  ];

  return (
    <>
      <div className="container-fluid features overflow-hidden py-5">
        <div className="container">
          <div className="section-title text-center mb-5" data-aos="fade-up" data-aos-delay="100">
            <div className="sub-style">
              <h5 className="sub-title" style={{ color: "#A71717" }}>ERP Modules</h5>
            </div>
            <h1 className="display-5 mb-4" style={{ color: "#A71717" }}>Comprehensive ERP Solution</h1>
            <p className="mb-0 text-muted">
              Our integrated ERP system offers a complete suite of modules to streamline your business operations
            </p>
          </div>

          <div className="row g-4 justify-content-center">
            {modules.map((module, i) => (
              <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay={100 + (i % 4) * 200} key={i}>
                <div className="feature-item text-center p-4 bg-white shadow-sm rounded">
                  <div className="feature-icon p-3 mb-4">
                    <i className={`fas ${module.icon} fa-3x`} style={{ color: "#A71717" }}></i>
                  </div>
                  <h5 style={{ color: "#A71717" }}>{module.title}</h5>
                  <p className="mb-0 text-muted">{module.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="row g-4 justify-content-center">
            {stats.map((stat, i) => (
              <div className="col-md-4" data-aos="fade-in" data-aos-delay={100 + i * 200} key={i}>
                <div className="service-stat text-center p-4">
                  <i className={`fas ${stat.icon} fa-3x mb-3`} style={{ color: "#A71717" }}></i>
                  <h1 className="mb-2" style={{ color: "#FFAA00" }}>{stat.value}</h1>
                  <h5>{stat.title}</h5>
                  <p className="mb-0 text-muted">{stat.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ERPModulesAndStats;
